import type { Problem } from "../types";

export const pl = {
  appName: "Tabliczka Misja Pi",
  answerLabel: "Wynik",
  answerPlaceholder: "?",
  check: "SPRAWDŹ",
  update: {
    message: "Jest nowa wersja aplikacji.",
    action: "Odśwież",
  },
  feedback: "Wpisz wynik i zatwierdź.",
  hint: {
    title: "Jak to zapamiętać?",
    retry: "Spróbuję jeszcze raz",
    equation: (problem: Problem, result: number) =>
      `${problem.a} x ${problem.b} = ${result}.`,
    rule: (problem: Problem) => {
      const { a, b } = problem;
      const [small, large] = [Math.min(a, b), Math.max(a, b)];

      if (small === 2)
        return "Razy 2 to podwajanie. Dodaj tę samą liczbę jeszcze raz.";
      if (small === 3)
        return `Razy 3 policz jako raz liczba + podwojenie: ${large} + ${large * 2}.`;
      if (small === 4)
        return "Razy 4 to dwa podwojenia: najpierw x2, potem jeszcze raz x2.";
      if (small === 5)
        return "Razy 5 zawsze kończy się na 0 albo 5. Połowa mnożenia przez 10 daje ten wynik.";
      if (small === 6)
        return `Razy 6 rozbij na 5 razy liczba i jeszcze jedną liczbę: ${large * 5} + ${large}.`;
      if (small === 7)
        return "Razy 7 rozbij na łatwiejsze 5x i 2x, a potem dodaj wyniki.";
      if (small === 8) return "Razy 8 to trzy podwojenia: x2, x4, x8.";
      if (small === 9)
        return `Razy 9 to prawie razy 10: ${large * 10} - ${large}.`;
      if (large === 10) return "Razy 10 dopisuje zero na końcu liczby.";

      return "Możesz zamienić kolejność liczb. Wynik jest taki sam, więc wybierz łatwiejszy kierunek.";
    },
  },
};
